import * as actionTypes from "./actionTypes";

export const onPost = (param, routeToCall, callback = () => {}) => {
  return {
    param,
    routeToCall,
    type: actionTypes.PEER_POST,
    callback,
  };
};


export const onGet = (routeToCall, callback = () => {}) => {
  return {
    routeToCall,
    type: actionTypes.PEER_GET,
    callback,
  };
};

